<template>
  <div style="padding: 0px 0px 10px 0px" class="bloc">
    <div style="padding: 0px 20px 0px 0px">
      <div>
        <div
          style="display:flex;min-height:27px;margin-left:15px;margin-top:5px;"
          v-if="
            indexSection !== undefined &&
            AllFolding[indexSection] !== undefined &&
            AllFolding[indexSection].questions !== undefined
              ? AllFolding[indexSection].questions.includes(indexQuestion)
              : AllFolding.includes(indexQuestion)
          "
        >
          <div
            class="handle-question frame-move-question-folding"
            @mouseleave="clickedDragIcon()"
            @mouseover="parentDragOn()"
          >
            <img
              src="@/assets/img/icons/drag-icon.png"
              class="icon-move"
              alt="icon-drop"
            />
          </div>
          <TitleQuestionAllFolding
            style="margin:auto 0px;"
            :AllFolding="AllFolding"
            :question="question"
            :indexQuestion="indexQuestion"
            :indexSection="indexSection"
          />
        </div>
        <div v-else>
          <div>
            <ListButtonsQuestion
              v-if="openListButtons"
              :indexQuestion="indexQuestion"
              :indexSection="indexSection"
              :elementTypeQuestion="question.element_type"
              :question="question"
              :AllFolding="AllFolding"
            />
            <div style="cursor:move; margin-left:15px;display: flex;">
              <div
                class="frame-move-question handle-question"
                @mouseleave="clickedDragIcon()"
              >
                <img
                  src="@/assets/img/icons/drag-icon.png"
                  class="icon-move"
                  alt="icon-drop"
                />
              </div>
              <ButtonImageQuestion :question="question" />
              <InputQuestionTranslation :question="question" />
            </div>
            <div style="margin-left:40px; margin-top:10px; margin-bottom:10px;">
              <OptionFacultative
                @checked="propsToParentAutre"
                :question="question"
                :elementTypeQuestion="question.element_type"
              />
              <OptionCheckboxes
                :question="question"
                :elementTypeQuestion="question.element_type"
              />
            </div>
          </div>
          <div>
            <div
              v-if="
                question.element_type != 'content' &&
                  question.element_type != 'notation'
              "
            >
              <draggable
                handle=".handle"
                v-model="answersDrag"
                @start="drag = true"
                @end="drag = false"
              >
                <template v-for="(answer, index) in answersDrag">
                  <div
                    v-if="answer.proposition_type !== 'content'"
                    :key="index"
                  >
                    <div class="columns" style="margin: 0px">
                      <div style="cursor:move;display: flex; width: 100%; margin: 5px 0px">
                        <div style="margin-left:15px;margin-right:15px;" class="handle frame-move-answer">
                          <img
                            @mouseover="dragDisabled = false"
                            @mouseleave="dragDisabled = false"
                            src="@/assets/img/icons/drag-icon.png"
                            class="icon-move"
                            alt="icon-drop"
                          />
                        </div>
                        <ButtonImageAnswer
                          :elementTypeQuestion="question.element_type"
                          :answer="answer"
                          :indexAnswer="index"
                          :indexQuestion="indexQuestion"
                          :indexSection="indexSection"
                        />
                        <div
                          @mouseover="parentDragOff()"
                          style="width: 100%; height: 27px"
                        >
                          <InputAnswersTranslation
                            :answer="answer"
                            :dragDisabled="dragDisabled"
                          />
                        </div>

                        <RemovePropositionButton
                          style="min-width:17px; min-height:17px;max-width:17px; max-height:17px;!important"
                          :question="question"
                          :indexProposition="index"
                        />
                      </div>

                      <div
                        v-if="$store.state.question.sections !== undefined"
                        style="margin: 5px 0px; display:flex;justify-content:flex-end;"
                      >
                        <DropdownSectionListAnswer
                          :indexQuestion="indexQuestion"
                          :indexSection="indexSection"
                          :indexProposition="index"
                          v-if="
                            question.element_type == 'radio' &&
                            $store.state.question.sections.length
                              ? $store.state.question.sections[indexSection]
                                  .questions[indexQuestion].relation_section
                              : false
                          "
                        />
                      </div>
                    </div>
                    <div class="mt-1">
                      <b-field
                        v-if="
                          question.element_type != 'select' &&
                            question.element_type != 'orderedChoices'
                        "
                      >
                        <div
                          style="margin-left:40px;margin-bottom:10px;"
                          v-if="answer.file_url"
                          class="illus_answer"
                          @click="deleteImgAnswer(index)"
                        >
                          <div class="delete_illus_answer">
                            <b-icon
                              pack="far"
                              icon="times-circle"
                              size="is-small"
                            ></b-icon>
                          </div>
                          <img :src="answer.file_url" />
                        </div>
                      </b-field>
                    </div>
                  </div>
                </template>
                <AddPropositionButton
                  style="display:flex;justify-content:flex-end;"
                  :question="question"
                />
              </draggable>
            </div>
          </div>
          <Notation :elementTypeQuestion="question.element_type" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
import EventBus from '@/eventBus'
import AddPropositionButton from '@/components/question/components/AddPropositionButton'
import RemovePropositionButton from '@/components/question/components/RemovePropositionButton'
import DropdownSectionListAnswer from '@/components/question/section/dropdown/DropdownSectionListAnswer'
import ListButtonsQuestion from '@/components/question/components/ListButtonsQuestion'
import InputQuestionTranslation from '@/components/question/components/InputQuestionTranslation'
import InputAnswersTranslation from '@/components/question/components/InputAnswersTranslation'
import ButtonImageQuestion from '@/components/question/components/ButtonImageQuestion'
import ButtonImageAnswer from '@/components/question/components/ButtonImageAnswer'

import OptionFacultative from '@/components/question/components/OptionFacultative'
import OptionCheckboxes from '@/components/question/components/OptionCheckboxes'
import Notation from '@/components/question/components/Notation'
import TitleQuestionAllFolding from '@/components/question/components/TitleQuestionAllFolding'
import ButtonFoldingQuestion from '@/components/question/components/ButtonFoldingQuestion'
export default {
  components: {
    AddPropositionButton,
    RemovePropositionButton,
    draggable,
    DropdownSectionListAnswer,
    ListButtonsQuestion,
    InputQuestionTranslation,
    ButtonImageQuestion,
    OptionFacultative,
    OptionCheckboxes,
    InputAnswersTranslation,
    ButtonImageAnswer,
    Notation,
    TitleQuestionAllFolding,
    ButtonFoldingQuestion
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    indexQuestion: {
      type: Number,
      required: true
    },
    indexSection: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      dragDisabled: true,
      answerInput: '',
      typeQuestionHistory: '',
      elementTypeQuestion: '',
      openListButtons: true
    }
  },
  watch: {
    question () {
      this.elementTypeQuestion = this.question.element_type
    }
  },

  updated () {
    this.$nextTick(function () {
      let message = {
        height: document.body.scrollHeight,
        width: document.body.scrollWidth
      }
      window.top.postMessage(message, '*')
    })
  },
  mounted () {
    this.elementTypeQuestion = this.question.element_type
    EventBus.$on('update_question', this.updateQuestionFunction)
  },
  beforeDestroy () {
    EventBus.$off('delete_imageAnswer')
  },
  methods: {
    deleteImgAnswer (index) {
      this.$store.commit('DELETE_IMG_ANSWER', {
        answer: this.question.answers[index],
        indexQuestion: this.indexQuestion,
        indexAnswer: index,
        indexSection: this.indexSection
      })
    },
    propsToParentAutre (value) {
      this.question.autre = Number(value)
      if (this.question.autre === 0) {
        this.question.answers.forEach(function (answer) {
          if (answer.proposition_type === 'content') {
            var PropositionToDelete = {
              question: this.question,
              indexProposition: answer.order
            }
            this.$store.commit('REMOVE_PROPOSITION', PropositionToDelete)
          }
        })
      }
    },
    openListButtonsFunction () {
      this.openListButtons = !this.openListButtons
    },
    updateQuestionFunction () {
      this.question = this.question
    },
    parentDragOn () {
      EventBus.$emit('clickedDragIcon', true)
      this.$store.commit('INDEX_SECTION_DRAG_HISTORY', {
        indexSection: this.indexSection,
        indexQuestion: this.indexQuestion
      })
      this.$emit('dragDisabled', false)
    },
    clickedDragIcon () {
      EventBus.$emit('clickedDragIcon', false)
    },
    parentDragOff () {
      this.$emit('dragDisabled', true)
    }
  },
  computed: {
    ...mapGetters(['AllFolding', 'type_formulaire', 'foldingQuestion']),
    answersDrag: {
      get: function () {
        return this.question.answers
      },
      set: function (newValue) {
        var payload = { newValue: newValue, question: this.question }
        this.$store.commit('UPDATE_PROPOSITION_ORDER', payload)
      }
    }
  }
}
</script>

<style scoped>
.ghost:active {
  background: #adadad;
  color: white;
  opacity: 1;
}
.frame-move-question-folding {
  margin-right: 15px;
  height: 27px;
  line-height: 27px;
}
.icon-move {
  min-width: 10px;
  cursor: move;
  height: 18px;
  vertical-align: middle;
}
.frame-move-question {
  margin-right: 15px;
  height: 120px;
  line-height: 120px;
}
.frame-move-answer {
  margin-right: 10px;
  height: 27px;
  line-height: 27px;
}
.icon {
  width: 15px;
  height: 15px;
  vertical-align: center;
  cursor: pointer;
}
.sortable-chosen {
  background: #d8d8d8;
  color:black;
  opacity: .3;
}
.proposition {
  padding: 5px;
}
.illus_question {
  position: relative;
  opacity: 1;
  /*height: 144px;*/
}
.illus_question:hover .overlay {
  opacity: 1;
  cursor: pointer;
}
.illus_question:hover img {
  cursor: pointer;
  opacity: 0.3;
}
.overlay {
  opacity: 0;
  position: absolute;
  top: 39%;
  left: 43%;
}
.illus_answer {
  position: relative;
  width: 142px;
  margin-left: 24px;
  padding: 10px;
  border: 1px gray dotted;
  /*height: 144px;*/
}

.delete_illus_question,
.delete_illus_answer {
  position: absolute;
  top: -11px;
  right: -9px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/question/BlocGabaritQuestion.vue